import { ReactElement, ReactNode } from 'react';
import { Container } from '@mui/material';
import { AppBreadcrumbs } from '../AppBreadcrumbs/AppBreadcrumbs';

type Props = {
  header: JSX.Element;
  children: ReactNode;
};

export function AppContainer({ header, children }: Props): ReactElement {
  return (
    <Container
      data-testid="app"
      maxWidth={false}
      disableGutters
      sx={{
        height: '100%',
      }}
    >
      {header}
      <AppBreadcrumbs data-testid="breadcrumbs" />
      <div data-testid="pageContent">{children}</div>
    </Container>
  );
}
